import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICancelEntradaGate,
  ICreateEntradaGate,
  IEditEntradaGate,
  IGetGateEntradaByIdRespone,
  IGetGateEntradaByIdResponse,
  IGetGateEntradaWithCaminhaoAtualInfoByIdParams,
  Items
} from './entradaGate.model';

@Injectable({
  providedIn: 'root'
})
export class EntradaGateService {
  constructor(private http: HttpClient) {}

  public CreateEntradaGate(
    body: ICreateEntradaGate,
    guid: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}GateEntrada/CreateGateEntrada`,
      body,
      { headers: headers }
    );
  }

  public UpdateEntradaGate(
    pkAgendamento: number,
    body: IEditEntradaGate
  ): Observable<any> {
    const url = `${environment.baseURL}GateEntrada/UpdateGateEntrada?id=${pkAgendamento}`;

    return this.http.put<any>(url, body);
  }

  public GetEntradaGateInfoById(
    id: number
  ): Observable<IGetGateEntradaByIdRespone> {
    const invalid = ['', undefined, 0, NaN];

    let url = `${environment.baseURL}GateEntrada/GetGateEntradaInfoById`;

    if (!invalid.includes(id)) {
      url += `?id=${id}`;
    }

    return this.http.get<any>(url);
  }

  public GetEntradasGate({
    codigoGateEntrada,
    idEmpresa,
    nomeMotorista,
    placaCavalo,
    numeroAgendamento,
    dtInicio,
    dtFim,
    status,
    pageNumber,
    pageSize,
    paginar = true
  }: {
    codigoGateEntrada?: string;
    idEmpresa?: string;
    nomeMotorista?: string;
    placaCavalo?: string;
    numeroAgendamento?: string;
    dtInicio?: string;
    dtFim?: string;
    status?: number;
    pageNumber?: number;
    pageSize?: number;
    paginar?: boolean;
  }): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    const url = `${environment.baseURL}GateEntrada/GetGateEntradasInfo`;
    const params: any = {};

    if (codigoGateEntrada !== undefined && codigoGateEntrada !== null) {
      params.PK_GATE_ENTR = codigoGateEntrada;
    }
    if (idEmpresa !== undefined && idEmpresa !== null) {
      params.PK_EPSA = idEmpresa;
    }
    if (nomeMotorista !== undefined && nomeMotorista !== null) {
      params.NM_MTRT = nomeMotorista;
    }
    if (placaCavalo !== undefined && placaCavalo !== null) {
      params.TX_PLCA_CAVA = placaCavalo;
    }
    if (numeroAgendamento !== undefined && numeroAgendamento !== null) {
      params.PK_AGND = numeroAgendamento;
    }
    if (dtInicio !== undefined && dtInicio !== null) {
      params.DT_GATE_ENTR_INIC = dtInicio;
    }
    if (dtFim !== undefined && dtFim !== null) {
      params.DT_GATE_ENTR_FIM = dtFim;
    }
    if (status !== undefined && status !== null) {
      params.NU_SAID_STTS = status;
    }
    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }
    if (!paginar) {
      params.PAGE_SIZE = 2147483647;
    }

    return this.http.get<any>(url, { params });
  }

  public GetReceiptGateEntradaById(
    id: number,
    tipoDocumento: number
  ): Observable<any> {
    const url = `${environment.baseURL}GateEntrada/GetReceiptGateEntradaById`;
    const params: any = {
      PK_GATE_ENTR: 0,
      FL_TIPO_DOCU: 0
    };

    params.PK_GATE_ENTR = id;
    params.FL_TIPO_DOCU = tipoDocumento;

    return this.http.get<any>(url, { params });
  }

  public CancelEntradaGate(body: ICancelEntradaGate): Observable<any> {
    const url = `${environment.baseURL}GateEntrada/CancelGateEntrada?id=${body.PK_GATE_ENTR}`;
    return this.http.put<any>(url, {
      TX_MOTV_CNCL_GATE_ENTR: body.TX_MOTV_CNCL_GATE_ENTR
    });
  }

  public GetGateEntradaWithCaminhaoAtualInfoById(
    params: IGetGateEntradaWithCaminhaoAtualInfoByIdParams
  ): Observable<Items> {
    const invalidParams = ['', null, undefined, NaN, 0];
    const validParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => !invalidParams.includes(value)
      )
    );

    let url = `${environment.baseURL}GateEntrada/GetGateEntradaWithCaminhaoAtualInfoById`;
    return this.http.get<any>(url, { params: validParams });
  }
}
